import { defineMessages } from 'react-intl-next';

export const i18n: {
    type: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    filterTypePlaceholder: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	type: {
		id: 'search-page.filters.names.type',
		defaultMessage: 'Type',
		description: 'Label for filtering by type',
	},
	filterTypePlaceholder: {
		id: 'search-page.filter.type.placeholder',
		defaultMessage: 'Find type',
		description: 'Placeholder for type filter search input',
	},
});
